var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2C10.7614 2 12.9999 4.22238 13 6.96387C13 8.75615 10.8626 11.5993 9.38281 13.3535C8.65066 14.2214 7.34934 14.2214 6.61719 13.3535C5.13735 11.5993 3 8.75615 3 6.96387C3.0001 4.22238 5.23864 2 8 2ZM8 4.48242C6.89543 4.48242 6 5.37114 6 6.46777C6.00007 7.56435 6.89547 8.45312 8 8.45312C9.10453 8.45312 9.99993 7.56435 10 6.46777C10 5.37114 9.10457 4.48242 8 4.48242Z",
    fill: "#8F8F8F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLocation);
export default __webpack_public_path__ + "static/media/location.0f522f8a4bcad1bbed98c651be1ad9b0.svg";
export { ForwardRef as ReactComponent };